import { BaseInquiryOfferLegendItemInterface } from 'base';

export const BaseCustomerInquiryOfferLegendItems: BaseInquiryOfferLegendItemInterface[] = [
  {
    status: 'offerRejected',
    icon: 'text-danger',
    iconBackground: 'bg-white border border-2 border-danger',
    iconText: 'shiftStatus.value.offered',
  },
  {
    status: 'offerSelected',
    icon: 'text-success',
    iconBackground: 'bg-white border border-2 border-success',
    iconText: 'shiftStatus.value.offered',
  },
  {
    status: 'booked',
    icon: 'text-primary',
    iconBackground: 'bg-white border border-2 border-primary',
    iconText: 'shiftStatus.value.booked',
  },
  {
    status: 'needsConfirmation',
    icon: 'text-white',
    iconBackground: 'bg-warning',
    iconText: 'shiftStatus.value.booked',
  },
  {
    status: 'offeredByProvider',
    icon: 'text-white',
    iconBackground: 'bg-light-gray',
    iconText: 'shiftStatus.value.offered',
  },
  { status: 'cancelled', icon: 'text-white fa-xmark', iconBackground: 'bg-danger' },
];
